import { IEventListState, IEventListItem, IEventState, IEvent } from 'entities/Events/Event.models';
import { EEventActionType } from 'entities/Events/Event.enum';

export const eventListReducers = {
  setList: (state: IEventListState, payload: IEventListItem[]) => ({ ...state, data: payload }),
  setLoading: (state: IEventListState, payload: boolean) => ({ ...state, loading: payload }),
  setCount: (state: IEventListState, payload: number) => ({ ...state, count: payload }),
  setWatchUpdates: (state: IEventListState, payload: boolean) => ({ ...state, watchUpdates: payload }),
};

export const eventReducers = {
  setEvent: (state: IEventState, payload: IEvent | null) => ({ ...state, data: payload }),
  setLoading: (state: IEventState, payload: boolean) => ({ ...state, loading: payload }),
  setAction: (state: IEventState, payload: EEventActionType | null) => ({ ...state, action: payload }),
  setText: (state: IEventState, payload: string | null) => ({ ...state, text: payload }),
  setPhysicianId: (state: IEventState, payload: number | null) => ({ ...state, physicianId: payload }),
};
